// api/homeWork.js
import axios from "axios";
import Cookies from "universal-cookie";
import { backendUrl } from "../utils/url";

const cookies = new Cookies();

const api = axios.create({
  baseURL: backendUrl,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${cookies.get("jwt-auth")}`,
  },
});

// ==========================================
// ========== مسیرهای مدیریتی ==========
// ==========================================

// @desc ایجاد تکلیف جدید
export const createhomeWorkQuestion = async (data) => {
  try {
    const res = await api.post("/homeWork/create", data);
    return res;
  } catch (err) {
    return err.response;
  }
};

// @desc دریافت همه تکالیف (فقط manager و questionMaker)
// 🆕 مسیر عوض شده: /homeWork/all → /homeWork/admin/all
export const getAllhomeWorkBanks = async (params) => {
  try {
    const res = await api.get("/homeWork/admin/all", { params });
    return res;
  } catch (err) {
    return err.response;
  }
};

// @desc دریافت یک تکلیف با شناسه
export const gethomeWorkBankById = async (id) => {
  try {
    const res = await api.get("/homeWork/" + id);
    return res;
  } catch (err) {
    return err.response;
  }
};

// @desc به‌روزرسانی تکلیف
// ⚠️ توجه: اینجا پارامتر data هم لازمه
export const updatehomeWorkBank = async (id, data) => {
  try {
    const res = await api.put("/homeWork/" + id, data);
    return res;
  } catch (err) {
    return err.response;
  }
};

// @desc حذف تکلیف
export const deletehomeWorkBank = async (id) => {
  try {
    const res = await api.delete("/homeWork/" + id);
    return res;
  } catch (err) {
    return err.response;
  }
};

// ==========================================
// ========== مسیرهای عمومی (با فیلتر نقش) ==========
// ==========================================

// 🆕 @desc دریافت تکالیف بر اساس درس‌ها (با فیلتر نقش)
export const getHomeWorksByLessons = async (params) => {
  try {
    const res = await api.get("/homeWork/", { params });
    return res;
  } catch (err) {
    return err.response;
  }
};

// 🆕 @desc دریافت تکالیف مرتبط با یک validityProcess
export const getHomeWorksByProcessId = async (processId) => {
  try {
    const res = await api.get(`/homeWork/process/${processId}`);
    return res;
  } catch (err) {
    return err.response;
  }
};

// 🆕 @desc افزایش تعداد استفاده
export const incrementHomeWorkUsage = async (id) => {
  try {
    const res = await api.get(`/homeWork/incrementuse/${id}`);
    return res;
  } catch (err) {
    return err.response;
  }
};
